import Note from "./Note";
import Question from "./Question";
import Explainer from "./Explainer";
import Translation from "./Translation";
import LyricSeparator from "./LyricSeparator";
import Part from "./Part";
import Block from "./Block";

const Ex = Explainer;
const Tr = Translation;

export default {
  Note,
  Question,
  Explainer,
  Ex,
  Translation,
  Tr,
  LyricSeparator,
  Part,
  Block,
};
